export enum RugbyUnionLineoutAttribute {
  Won = 2984,
  Lost = 2985,
}
